import { useLocation } from 'react-router';

const useQuerySearch = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  return query;
}

export default useQuerySearch;